// extracted by mini-css-extract-plugin
export default {"categoriesForm":"CategoriesTemplate_categoriesForm__-QwX3"};